import React from "react";
import Icon from "../Icon/Icon";

export const IconButton = ({ iconName, ...props }) => {
  return (
    <button {...props}>
      <Icon name={iconName} />
    </button>
  );
};
